import {mixins} from "../app/mixin";

mixins.push({
    el: '.ecovadisSkillWrapper',
    data() {
        return {
            selectedSkill: 1,
        }
    },
    methods: {
        selectSkill(skill) {
            this.selectedSkill = skill;
        },
    },
});